import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Cookies = ({ pageContext }) => (
  <Layout {...pageContext}>
    <SEO
      lang={pageContext.lang}
      path={pageContext.pageUrl}
      title={pageContext.title}
      noindex={true}
    />
    <div id="header" className="for-properties">
      <div className="section-content">
        <div className="big-text">
          <h1 className="t-left f-large normal">{pageContext.title}</h1>
        </div>
      </div>
    </div>
    <div id="description">
      <div className="section-content">
        <div className="row">
          <div className="col-md-8">
            <div
              className="brief no-margin t-left link-underline"
              dangerouslySetInnerHTML={{ __html: pageContext.contentHtml }}
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default Cookies
